import React from 'react';

import {ACCOUNT_ROUTES_DATA} from './account/accountRoutesData';
import {ADMIN_ROUTES_DATA} from './admin/adminRoutesData';
import {AUTH_ROUTES_DATA} from './auth/authRoutesData';
import {AUTOMATIONS_ROUTES_DATA} from './automations/automationsRoutesData';
import {INFERENCE_ROUTES_DATA} from './inference/inferenceRoutesData';
import {LAUNCH_ROUTES_DATA} from './launch/launchRoutesData';
import {
  ACADEMIC_APPLICATION_ROUTE_DATA,
  ONBOARDING_ROUTES_DATA,
  TRIAL_END_ROUTE_DATA,
} from './onboarding/onboardingRoutesData';
import {ORG_ROUTES_DATA} from './organization/orgRoutesData';
import {HOME_PATH, NO_ACCESS_PATH, PROJECT_PATHS, REDIRECT_PATH} from './paths';
import {REGISTRY_ROUTES_DATA} from './registry/registryRoutesData';
import {
  FULLY_CONNECTED_ROUTES_DATA,
  REPORT_ROUTES_DATA,
} from './report/reportRoutesData';
import {SANDBOXES_ROUTES_DATA} from './sandboxes/sandboxesRoutesData';
import {PROFILE_PATH} from './team/teamPaths';
import {
  CREATE_TEAM_ROUTE_DATA,
  PROFILE_ROUTES_DATA,
  TEAM_ROUTES_DATA,
} from './team/teamRoutesData';
import {type RouteData} from './types';
import {
  HISTORIC_USAGE_ROUTES_DATA,
  STORAGE_EXPLORER_ROUTES_DATA,
} from './usage/usageRoutesData';
import {REDIRECT_WEAVE_ENTITY_ROUTE_DATA} from './weave/weaveRoutesData';
import {GROUP_WORKSPACE_ROUTES_DATA} from './workspace/groupWorkspaceRoutesData';
import {PROJECT_BASE_PATH} from './workspace/multiRunWorkspacePaths';
import {SWEEP_ROUTES_DATA} from './workspace/sweepRoutesData';

export const ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'Home',
    },
    exact: true,
    isPrivateRoute: false,
    path: '/',
    RouteComponent: React.lazy(
      () => import('../pages/HomePage/HomePageRouter')
    ),
  },
  {
    additionalProps: {
      allowIframes: false,
      skipTracking: true, // HomePageWithData handles tracking via HOME_NESTED_ROUTES
    },
    exact: true,
    isPrivateRoute: true,
    path: HOME_PATH,
    RouteComponent: React.lazy(
      () => import('../pages/HomePage/HomePageWithData')
    ),
  },
  ...AUTH_ROUTES_DATA,
  ...ONBOARDING_ROUTES_DATA,
  ...ADMIN_ROUTES_DATA,
  ...FULLY_CONNECTED_ROUTES_DATA,
  ...AUTOMATIONS_ROUTES_DATA,
  ...INFERENCE_ROUTES_DATA,
  REDIRECT_WEAVE_ENTITY_ROUTE_DATA, // IMPORTANT: weave redirect route needs to come before the generic /:entityName so it matches first and redirects
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'ErrorTestPage',
    },
    exact: true,
    isPrivateRoute: false,
    path: '/__test/simple_error',
    RouteComponent: React.lazy(() => import('../pages/ErrorTestPage')),
  },
  ...ACCOUNT_ROUTES_DATA,
  CREATE_TEAM_ROUTE_DATA,
  ...ORG_ROUTES_DATA,
  ...STORAGE_EXPLORER_ROUTES_DATA,
  ...PROFILE_ROUTES_DATA, // Profile routes must come before TEAM_ROUTES_DATA to match /profile/:entityName first
  ...TEAM_ROUTES_DATA,
  ...REGISTRY_ROUTES_DATA, // IMPORTANT: registry routes need to come before the other entity routes
  ...LAUNCH_ROUTES_DATA,
  ...SANDBOXES_ROUTES_DATA,
  ...GROUP_WORKSPACE_ROUTES_DATA,
  ...SWEEP_ROUTES_DATA,
  ...REPORT_ROUTES_DATA,
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'NoAccess',
    },
    exact: true,
    isPrivateRoute: false,
    path: NO_ACCESS_PATH,
    RouteComponent: React.lazy(() => import('../pages/NoAccessPage')),
  },
  ...HISTORIC_USAGE_ROUTES_DATA,
  {
    additionalProps: {
      allowIframes: true,
      skipTracking: true, // ProjectPage handles tracking via PROJECT_NESTED_ROUTES
    },
    exact: true,
    isPrivateRoute: false,
    path: PROJECT_PATHS,
    RouteComponent: React.lazy(() => import('../pages/ProjectPage')),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'Redirect',
    },
    exact: true,
    isPrivateRoute: false,
    path: REDIRECT_PATH,
    RouteComponent: React.lazy(
      () => import('../pages/RedirectPage/RedirectPage')
    ),
  },
  {
    // this is here to truncate extra path segments after the actual path
    path: PROJECT_BASE_PATH,
    redirect: PROJECT_BASE_PATH,
  },
  TRIAL_END_ROUTE_DATA,
  ACADEMIC_APPLICATION_ROUTE_DATA,
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'Entity',
    },
    exact: true,
    isPrivateRoute: false,
    path: PROFILE_PATH,
    RouteComponent: React.lazy(() => import('../pages/EntityPage')),
  },
];
